export class Icon {
  alt: string;
  src: string;
  constructor(data?: Icon) {
    this.alt = data?.alt ?? '';
    this.src = data?.src ?? '';
  }
}


export const IconsArray: Icon[] = [
  {
    alt: "default",
    src: ""
  },
  {
    alt: "header-menu",
    src: "app/assets/icons/button-menu.svg",
  },
  {
    alt: "logo",
    src: "app/assets/icons/logo.svg",
  },
  {
    alt: "photo",
    src: "app/assets/icons/photo-1.svg",
  },
  {
    alt: "photo",
    src: "app/assets/icons/photo-main-loading.svg",
  },
  {
    alt: "photo",
    src: "app/assets/icons/photo-3.svg",
  },
  {
    alt: "map",
    src: "app/assets/icons/map.svg",
  },
  {
    alt: "music",
    src: "app/assets/icons/music.jpeg",
  },
  {
    alt: "logo",
    src: "app/assets/icons/rzd-logo.svg",
  },
  {
    alt: "win",
    src: "app/assets/icons/80-win.svg",
  },
  {
    alt: "magnifiger",
    src: "app/assets/icons/magnifiger.svg",
  },
  {
    alt: "menu",
    src: "app/assets/icons/toast-menu.svg",
  },
  {
    alt: "mother",
    src: "app/assets/icons/mother.svg",
  },
  {
    alt: "vk",
    src: "app/assets/icons/vk.svg",
  },
  {
    alt: "tg",
    src: "app/assets/icons/tg.svg",
  },
  {
    alt: "upload-files",
    src: "app/assets/icons/upload-files.svg",
  },
  {
    alt: "cross-close",
    src: "app/assets/icons/cross-close.svg",
  },
  {
    alt: "win",
    src: "app/assets/icons/win-white.svg",
  },
  {
    alt: "star",
    src: "app/assets/icons/star.svg",
  },
  {
    alt: "target",
    src: "app/assets/icons/target.svg",
  },
  {
    alt: "cross",
    src: "app/assets/icons/cross.svg",
  },
  {
    alt: "buttonArrow",
    src: "app/assets/icons/button-arrow.svg",
  },
  {
    alt: "mainLoading",
    src: "app/assets/icons/main-loading.svg",
  },
  {
    alt: "minus",
    src: "app/assets/icons/minus.svg",
  },
  {
    alt: "plus",
    src: "app/assets/icons/plus.svg",
  },
  {
    alt: "vk",
    src: "app/assets/icons/vkWhite.svg",
  },
  {
    alt: "tg",
    src: "app/assets/icons/tgWhite.svg",
  },
  {
    alt: "show",
    src: "app/assets/icons/show.svg",
  },
  {
    alt: "magnifirerMinus",
    src: "app/assets/icons/magnifirerMinus.svg",
  },
  {
    alt: "magnifirerPlus",
    src: "app/assets/icons/magnifirerPlus.svg",
  },
  {
    alt: "arrow2",
    src: "app/assets/icons/arrow2.svg",
  },
  {
    alt: "bomb",
    src: "app/assets/icons/bomb.svg",
  },
  {
    alt: "medal",
    src: "app/assets/icons/medal.svg",
  },
  {
    alt: "train",
    src: "app/assets/icons/train.svg",
  },
  {
    alt: "fist",
    src: "app/assets/icons/fist.svg",
  },
  {
    alt: "attention",
    src: "app/assets/icons/attention.svg",
  },
  {
    alt: "evacuation",
    src: "app/assets/icons/evacuation.svg",
  },
  {
    alt: "crane",
    src: "app/assets/icons/crane.svg",
  },
  {
    alt: "gear",
    src: "app/assets/icons/gear.svg",
  },
  {
    alt: "helmet",
    src: "app/assets/icons/helmet.svg",
  },
  {
    alt: "ashoka",
    src: "app/assets/icons/ashoka.svg",
  },
  {
    alt: "crossWhite",
    src: "app/assets/icons/cross-white.svg",
  },
  {
    alt: "camera",
    src: "app/assets/icons/camera.svg",
  },
];
export const Icons = {
  default: IconsArray[0],
  headerMenu: IconsArray[1],
  logo: IconsArray[2],
  photo1: IconsArray[3],
  photo2: IconsArray[4],
  photo3: IconsArray[5],
  map: IconsArray[6],
  music: IconsArray[7],
  logoRzd: IconsArray[8],
  win: IconsArray[9],
  magnifiger: IconsArray[10],
  menu: IconsArray[11],
  mother: IconsArray[12],
  vk: IconsArray[13],
  tg: IconsArray[14],
  uploadFiles: IconsArray[15],
  crossClose: IconsArray[16],
  winWhite: IconsArray[17],
  star: IconsArray[18],
  target: IconsArray[19],
  cross: IconsArray[20],
  buttonArrow: IconsArray[21],
  mainLoading: IconsArray[22],
  minus: IconsArray[23],
  plus: IconsArray[24],
  vkWhite: IconsArray[25],
  tgWhite: IconsArray[26],
  show: IconsArray[27],
  magnifirerMinus: IconsArray[28],
  magnifirerPlus: IconsArray[29],
  arrow2: IconsArray[30],
  bomb: IconsArray[31],
  medal: IconsArray[32],
  train: IconsArray[33],
  fist: IconsArray[34],
  attention: IconsArray[35],
  evacuation: IconsArray[36],
  crane: IconsArray[37],
  gear: IconsArray[38],
  helmet: IconsArray[39],
  ashoka: IconsArray[40],
  crossWhite: IconsArray[41],
  panorama: IconsArray[42],
  camera: IconsArray[43],
}
